var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 10.1L9 8.3c.6-.8 1-1.7 1-2.8C10 3 8 1 5.5 1S1 3 1 5.5 3 10 5.5 10c1.1 0 2-.4 2.8-1l1.9 1.9c.1.1.2.1.4.1s.3 0 .4-.1c0-.2 0-.6-.1-.8zM2 5.5C2 3.6 3.6 2 5.5 2S9 3.6 9 5.5c0 1-.4 1.8-1 2.5-.7.6-1.5 1-2.5 1C3.6 9 2 7.4 2 5.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEyIDEyIiA+DQoJPHBhdGggZD0iTTEwLjksMTAuMUw5LDguM2MwLjYtMC44LDEtMS43LDEtMi44QzEwLDMsOCwxLDUuNSwxUzEsMywxLDUuNVMzLDEwLDUuNSwxMGMxLjEsMCwyLTAuNCwyLjgtMWwxLjksMS45YzAuMSwwLjEsMC4yLDAuMSwwLjQsMC4xczAuMywwLDAuNC0wLjFDMTEsMTAuNywxMSwxMC4zLDEwLjksMTAuMXogTTIsNS41QzIsMy42LDMuNiwyLDUuNSwyUzksMy42LDksNS41YzAsMS0wLjQsMS44LTEsMi41YzAsMCwwLDAsMCwwczAsMCwwLDBDNy4zLDguNiw2LjUsOSw1LjUsOUMzLjYsOSwyLDcuNCwyLDUuNXoiLz4NCjwvc3ZnPg0K";
export { SvgSearch as ReactComponent };